import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-collapse-button',
  template: `
    <button
      type="button"
      class="btn btn-sm btn-outline-secondary icon-btn"
      [attr.aria-expanded]="isExpanded"
      [attr.aria-label]="(isExpanded ? 'i18n.domain.theme-showcase.sections.collapse' : 'i18n.domain.theme-showcase.sections.expand') | translate"
      (click)="toggle()">
      <span class="icon-chevron--up collapse-button__icon" [class.collapse-button__icon--expanded]="isExpanded" aria-hidden="true"></span>
    </button>
  `,
  styles: `
    .collapse-button__icon {
      display: inline-block;
      transition: transform 0.4s ease-in-out;
      transform: rotate(-180deg);
    }
    .collapse-button__icon--expanded {
      transform: rotate(0deg);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe]
})
export class CollapseButtonComponent {
  @Input() public isExpanded = true;
  @Output() public toggleExpand = new EventEmitter<void>();

  public toggle(): void {
    this.toggleExpand.emit();
  }
}
